import { isNil } from 'shared/src/utils';

export const extractTagInfo = (str: string | null) => {
  if (isNil(str)) {
    return {
      head: null,
      isBold: false,
      isFont: false,
      color: null,
      inner: null,
      tail: null,
    };
  }
  const regex =
    /(.*?)<([a-zA-Z]+)(?:\s+[^>]*?)?(?:color="([^"]*)")?[^>]*>(.*?)<\/\2>\s*(.*)/i;
  const match = str.match(regex);

  if (!match) {
    return {
      head: null,
      isBold: false,
      isFont: false,
      color: null,
      inner: null,
      tail: null,
    };
  }

  const tag = match[2].toLowerCase();

  return {
    head: match[1] || null,
    isBold: tag === 'b',
    isFont: tag === 'font',
    color: match[3] || null,
    inner: match[4],
    tail: match[5],
  };
};
